export default __webpack_public_path__ + "static/media/ContainerIcon.aa554cac.svg";